import React, { useEffect } from "react";

const Modal = ({ message, isError, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg text-center max-w-[400px] w-full">
        <div className="flex justify-center items-center mb-4">
          {isError ? (
            <div className="flex justify-center items-center w-16 h-16 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="256"
                   height="256" viewBox="0 0 256 256">
                <defs></defs>
                <g
                  style={{stroke: "none", strokeWidth: 0, strokeDasharray: "none", strokeLinecap: "butt", strokeLinejoin: "miter", strokeMiterlimit: 10, fill: "none", fillRule: "nonzero", opacity: 1}}
                  transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                  <path
                    d="M 28.5 65.5 c -1.024 0 -2.047 -0.391 -2.829 -1.172 c -1.562 -1.562 -1.562 -4.095 0 -5.656 l 33 -33 c 1.561 -1.562 4.096 -1.562 5.656 0 c 1.563 1.563 1.563 4.095 0 5.657 l -33 33 C 30.547 65.109 29.524 65.5 28.5 65.5 z"
                    style={{stroke: "none", strokeWidth: 1, strokeDasharray: "none", strokeLinecap: "butt", strokeLinejoin: "miter", strokeMiterlimit: 10, fill: "rgb(236,0,0)", fillRule: "nonzero", opacity: 1}}
                    transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                  <path
                    d="M 61.5 65.5 c -1.023 0 -2.048 -0.391 -2.828 -1.172 l -33 -33 c -1.562 -1.563 -1.562 -4.095 0 -5.657 c 1.563 -1.562 4.095 -1.562 5.657 0 l 33 33 c 1.563 1.562 1.563 4.095 0 5.656 C 63.548 65.109 62.523 65.5 61.5 65.5 z"
                    style={{stroke: "none", strokeWidth: 1, strokeDasharray: "none", strokeLinecap: "butt", strokeLinejoin: "miter", strokeMiterlimit: 10, fill: "rgb(236,0,0)", fillRule: "nonzero", opacity: 1}}
                    transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                  <path
                    d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z M 45 8 C 24.598 8 8 24.598 8 45 c 0 20.402 16.598 37 37 37 c 20.402 0 37 -16.598 37 -37 C 82 24.598 65.402 8 45 8 z"
                    style={{stroke: "none", strokeWidth: 1, strokeDasharray: "none", strokeLinecap: "butt", strokeLinejoin: "miter", strokeMiterlimit: 10, fill: "rgb(236,0,0)", fillRule: "nonzero", opacity: 1}}
                    transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                </g>
              </svg>
            </div>
          ) : (
            <div className="flex justify-center items-center w-16 h-16 rounded-full bg-green-100">
              <svg className="w-8 h-8 text-green-600" fill="white" viewBox="0 0 20 20">
                <path fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                      clipRule="evenodd" />
              </svg>
            </div>
          )}
        </div>

        <h2 className={`text-2xl font-semibold ${isError ? "text-red-600" : "text-green-600"}`}>
          {isError ? "Oops!" : "Success!"}
        </h2>

        <p className="mt-2 text-gray-600">{message}</p>
      </div>
    </div>
  );
}

export default Modal;